<template>
  <div class="box online_bg">
    <v-dialog/>
    <div class="wrap w1200">
      <!--右侧列表-->
      <div class="onsite_b task_jihua_detail">
        <!--顶部详情-->
        <div class="top_con">
          <dl style="position: relative;">
            <dt>
              <span class="btn_end" v-if="tipText">{{tipText}}</span>
              <span class="btn_end" v-if="tipText">{{tipText}}</span>
              <img src="@/assets/images/zy_2.jpg" v-if="!form.cover || form.cover == ''" />
              <img :src="form.cover" v-if="form.cover && form.cover !== ''">
            </dt>
            <dd>
              <h3 class="enroll_title">
                <span :title="form.name">{{form.name}}</span>
                <div class="enroll_type_freeStatus">
                  <span class="enroll_icon_free" v-if="form.cost == 0"></span>
                  <span class="enroll_icon_charge" v-if="form.cost != 0"></span>
                  <span v-if="form.type == '01'" class="entroll_type rt">线上课程</span>
                  <span v-if="form.type == '02'" class="entroll_type rt">直播</span>
                  <span v-if="form.type == '03'" class="entroll_type rt">计划</span>
                  <span v-if="form.type == '04'" class="entroll_type rt">线下课程</span>
                </div>
              </h3>
              <!--<ul>
                <li v-for="item in resourceList" :key="item.id">
                  <router-link v-if="item.typeName == '课程'" :to="path + '/courseDetail/' + item.id" style="text-decoration: underline; cursor: pointer;">{{item.name}}</router-link>
                  <router-link v-if="item.typeName == '计划'" :to="path + '/plan/' + item.id" style="text-decoration: underline; cursor: pointer;">{{item.title}}</router-link>
                  <router-link v-if="item.typeName == '直播'" :to="path + '/livePlayDetail/' + item.id" style="text-decoration: underline; cursor: pointer;">{{item.name}}</router-link>
                  <span style="display: inline-block; font-size: 12px; line-height: 12px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">{{item.typeName}}</span>
                </li>
              </ul>-->
              <div class="enroll_detail_info">
                <div class="enroll_info_item">
                  <div class="info_item_title"><i class="enroll_icon_time"></i><span class="enroll_text">报名时间</span></div>
                  <div class="info_item_content" :class="{ 'enrroll_a': $utils.judgmentState(form.starttime, form.endtime) === '1', 'enrroll_b': $utils.judgmentState(form.starttime, form.endtime) === '0', 'enrroll_c': $utils.judgmentState(form.starttime, form.endtime) === '2' }" >{{ dateFormat(new Date(form.starttime), 'yyyy-MM-dd') }} 至 {{ dateFormat(new Date(form.endtime), 'yyyy-MM-dd') }}</div>
                </div>
                <div class="enroll_info_item">
                  <div class="info_item_title"><i class="enroll_icon_time"></i><span class="enroll_text">授课时间</span></div>
                  <div class="info_item_content" :class="{ 'enrroll_a': $utils.judgmentState(form.lectureStartTime, form.lectureEndTime) === '1', 'enrroll_b': $utils.judgmentState(form.lectureStartTime, form.lectureEndTime) === '0', 'enrroll_c': $utils.judgmentState(form.lectureStartTime, form.lectureEndTime) === '2' }" >{{ dateFormat(new Date(form.lectureStartTime), 'yyyy-MM-dd hh:mm') }} 至 {{ dateFormat(new Date(form.lectureEndTime), 'yyyy-MM-dd hh:mm') }}</div>
                </div>
              </div>

              <div class="enroll_detail_info">
                <div class="enroll_info_item">
                  <div class="info_item_title"><i class="enroll_icon_addr"></i><span class="enroll_text">授课地点</span></div>
                  <div class="info_item_content">{{form.site}}</div>
                </div>
                <div class="enroll_info_item">
                  <div class="info_item_title"><i class="enroll_icon_teacher"></i><span class="enroll_text">讲师</span></div>
                  <div class="info_item_content">
                    <span v-for="item in teacherList" :key="item.id">
                    {{item.name}}&nbsp;&nbsp;
                  </span>
                  </div>
                </div>
              </div>
              <a style="cursor: pointer;top:225px;" v-if="(form.timeState == 2) && (enrollStatus == '2' || enrollStatus == '')" v-debounce-click @click="goEnroll(form)" class="btn_go">报名</a>
            </dd>
          </dl>
        </div>
        <!--/顶部详情-->
        <div class="tab_content">
          <div class="w890" style="padding: 10px;">
            <div v-html="form.content" v-if="form.content"></div>
          </div>
        </div>
      </div>
      <!--/右侧列表-->
      <div class="clear"></div>
    </div>
    <div class="tan kcfl_add" style="display:none;">
      <div class="px_add_con" style="width: 400px; height: 300px; margin-left: -200px;">
        <div class="h250 rdiv">
          <h3>{{formRequired}}</h3>
          <a  href="javascript:void(0);"  class="close" @click="$utils.fadeOut('.kcfl_add')" ></a>
          <div style="height: 200px; padding: 5px;">
            <input type="radio" name="enroll-form-radio" class="enroll-form" value="1" checked />&nbsp;&nbsp;是&nbsp;&nbsp;
            <input type="radio" class="enroll-form enroll-form-no" name="enroll-form-radio" value="0" />&nbsp;&nbsp;否&nbsp;&nbsp;
            <textarea id="enroll-form" class="put_495 textarea_style" placeholder="请填写样机型号"></textarea>
          </div>
        </div>
        <div class="clear"></div>
        <div class="w240 wrap mt5">
          <input type="button" value="确定" class="all_btn" @click="submitForm(enrollform)" />
          <input type="button" value="取消" @click="$utils.fadeOut('.kcfl_add')" class="all_btn color_hui" style="background: #ccc;"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import rangePermission from '@/utils/rangePermission'
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: {},
    props: {
      path: {
        type: String
      },
      formRequired: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        panel: '1',
        form: {},
        enrollform: {},
        planItemList: [],
        resourceList: [],
        teacherList: [],
        currentCs: [],
        certList: [],
        cert: {},
        totalCredits: 0,
        tipText: '',
        enrollStatus: ''
      }
    },
    created () {
      this.getModel(this.$route.params.id)
      if (getCookie(process.env.TOKEN_KEY)) {
        this.getEnrollStatus(this.$route.params.id)
      }
      /*rangePermission.checkScope({ // 防盗链
        itemId: this.$route.params.id,
        itemType: '04',
        permission: '02'
      }).then((r) => {
        if (!r.data) {
          let path = (process.env.NODE_ENV == 'development') ? 'http://localhost:8081' : config.domains[0] + ':' + config.webport
          window.location.href = path
        }
      })*/
    },
    mounted () {
      this.$on('data-prepared', function (data) {
        switch (data.type) {
          case '01': {
            this.getCourseListByIds([data.businessId])
            break
          }
          case '04': {
            this.getCourseListByIds([data.businessId])
            break
          }
          case '02': {
            this.getLivePlayListByIds([data.businessId])
            break
          }
          case '03': {
            this.getPlanListByIds([data.businessId])
            break
          }
        }
      });
    },
    methods: {
      dateFormat: utils.dateFormat,
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      getModel (id) {
        api.get(config.enrollApiPath, '/signupinfo/get', { id: id }, (r) => { // 正常
          this.form = r.data
          if (this.form.teachers) {
            this.getTeacherListByIds(this.form.teachers.split(','))
          }
          this.$emit('data-prepared', this.form)
        })
      },
      getEnrollStatus (id) {
        this.$api.post(this.$global.enrollApiPath, '/signupuser/search', {pageNo: 1, pageSize: 12, signupid: id}, r => {
          var state = !!(r.data) // 该报名是否已创建过报名记录（无论是否付费或确认）
          if (r.data) { this.enrollStatus = r.data[0].state }
          if (state) { //
            if (r.data && r.data[0]) {
              var s = r.data[0].state
              if (s == '1') { // 已确认
                this.tipText = '您已报名'
              } else if (s == '0' || s == '2') { // 未确认的话需要先删除掉原来记录
                if (s == '0') {
                  this.tipText = '您的报名在确认中'
                }
                if (s == '2') {
                  this.tipText = '您的报名已被拒绝'
                }
              }
            }
          }
        })
      },
      openForm (item) {
        this.$utils.fadeIn('.kcfl_add')
      },
      submitForm (item) {
        let v = $('input:radio[name=enroll-form-radio]:checked').val()
        var _submit = () => {
          item.remarks = v + '|' + $('#enroll-form').val()
          this.$utils.fadeOut('.kcfl_add')
          this.goPay(item)
        }
        if (v == '1') { // 选择了“是”
          if (!$('#enroll-form').val()) {
            this.$toasted.show('请填写样机型号')
          } else {
            _submit()
          }
        } else {
          _submit()
        }
      },
      goEnroll (item) {
        this.enrollform = item
        if (getCookie(process.env.TOKEN_KEY)) {
          this.$api.post(this.$global.enrollApiPath, '/signupuser/search', {pageNo: 1, pageSize: 12, signupid: item.id}, r => {
            var state = !!(r.data) // 该报名是否已创建过报名记录（无论是否付费或确认）
            if (state) { //
              if (r.data && r.data[0]) {
                var s = r.data[0].state
                if (s == '1') { // 已确认
                  this.$toasted.show('您已报名')
                  this.tipText = '您已报名'
                } else if (s == '0' || s == '2') { // 未确认的话需要先删除掉原来记录
                  if (s == '0') {
                    this.$toasted.show('您的报名在确认中')
                    this.tipText = '您的报名在确认中'
                  }
                  if (s == '2') {
                    this.$toasted.show('您的报名已被拒绝, 请联系机构管理员')
                    this.tipText = '您的报名已被拒绝'
                  }
                }
              }
            } else {
              if (this.formRequired) {
                if ((parseInt(item.number) >0) && (parseInt(item.userCnt) >= parseInt(item.number))) {
                  this.$toasted.show('对不起, 报名人数已满')
                } else {
                  this.openForm(item)
                }
              } else {
                this.goPay(item)
              }
            }
          })
        } else {
          this.$toasted.show('请先登录')
        }
      },
      goPay (item) {
        var that = this
        if (getCookie(process.env.TOKEN_KEY)) {
          if ((parseInt(item.number) >0) && (parseInt(item.userCnt) >= parseInt(item.number))) {
            this.$toasted.show('对不起, 报名人数已满')
          }
          if (item.number == '0' || item.userCnt <= item.number) {
            this.$api.post(this.$global.enrollApiPath, '/signupuser/search', {pageNo: 1, pageSize: 12, signupid: item.id}, r => {
              var state = !!(r.data) // 该报名是否已创建过报名记录（无论是否付费或确认）
              var _addEnroll = function () {
                that.confirmBox({
                  title: '报名',
                  text: '确认报名吗？',
                  yes: function () {
                    that.$api.post(that.$global.enrollApiPath, '/signupuser/save', { // 生成报名记录
                      signupid: item.id,
                      remarks: item.remarks,
                      payState: '0'
                    }, r => {
                      if (r.data) {
                        if (item.cost > 0) { // 不免费才需要购买, 跳转至支付页面
                          that.$router.push({path: that.prefix + '/enrollPay/' + item.id + '/' + '1' + '/' + r.data.id + '/' + (that.orgType ? that.orgType : 'custom') + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
                        } else { // 免费报名成功
                          that.$modal.hide('dialog')
                          that.$toasted.show('报名成功')
                          that.getEnrollStatus(that.$route.params.id)
                        }
                      }  else {
                        that.$toasted.show('系统繁忙, 请稍后再试')
                      }
                    })
                  }
                })
              }
              if (state) { //
                if (r.data && r.data[0]) {
                  var s = r.data[0].state
                  if (s == '1') { // 已确认
                    this.$toasted.show('您已报名')
                    this.tipText = '您已报名'
                  } else if (s == '0' || s == '2') { // 未确认的话需要先删除掉原来记录
                    if (s == '0') {
                      this.$toasted.show('您的报名在确认中')
                      this.tipText = '您的报名在确认中'
                    }
                    if (s == '2') {
                      this.$toasted.show('您的报名已被拒绝, 请联系机构管理员')
                      this.tipText = '您的报名已被拒绝'
                    }
                    var payState = null // 获取当前支付状态paystate
                    if (r.data && r.data[0].paystate) {
                      payState = r.data[0].paystate
                    } else { // 没有支付状态
                      payState = '2'
                    }
                    var sid = r.data[0].id
                    if (payState == '2' && Number(item.cost) > 0) { // 重新报名
                      that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
                        that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', { // 删除报名记录
                          id: sid
                        }, r => {
                          _addEnroll()
                        })
                      }, e => {
                        if (e=='PAY_ERROR_00014') { // 支付成功了，刷新页面
                          that.getEnrollStatus(that.$route.params.id)
                        }
                      })
                    } else if (payState == '0' && Number(item.cost) > 0) { // 生成了订单但未完成支付
                      that.$modal.show('dialog', {
                        title: '支付',
                        text: '该报名存在未完成支付订单，是否继续支付？',
                        buttons: [
                          {
                            title: '继续',
                            default: true,
                            handler: () => {
                              that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
                                that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: sid}, r => {
                                  that.$api.post(that.$global.enrollApiPath, '/signupuser/save', { // 生成报名记录
                                    signupid: item.id,
                                    remarks: item.remarks,
                                    payState: '0'
                                  }, r => {
                                    if (r.data) {
                                      if (item.cost > 0) { // 不免费才需要购买, 跳转至支付页面
                                        that.$router.push({path: that.prefix + '/enrollPay/' + item.id + '/' + '1' + '/' + r.data.id + '/' + (that.orgType ? that.orgType : 'custom') + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
                                      } else { // 免费报名成功
                                        that.$modal.hide('dialog')
                                        that.$toasted.show('报名成功')
                                        that.getEnrollStatus(that.$route.params.id)
                                      }
                                    }  else {
                                      that.$toasted.show('系统繁忙, 请稍后再试')
                                    }
                                  })
                                }, e => {
                                  that.$toasted.show(e.message, {
                                    duration: 800
                                  })
                                })
                              }, e => {
                                if (e == 'PAY_ERROR_00014') {
                                  that.getEnrollStatus(that.$route.params.id)
                                }
                              })
                            }
                          },
                          {
                            title: '取消订单',
                            handler: () => {
                              that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
                                that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: sid}, r => {
                                  that.$modal.hide('dialog')
                                  that.$toasted.show('订单取消成功！', {
                                    duration: 800
                                  })
                                  that.getEnrollStatus(that.$route.params.id)
                                }, e => {
                                  that.$toasted.show(e.message, {
                                    duration: 800
                                  })
                                })
                              }, e => {
                                if (e == 'PAY_ERROR_00014') {
                                  that.getEnrollStatus(that.$route.params.id)
                                }
                              })
                            }
                          }
                        ]
                      })
                    }
                  }
                }
              } else { // 没有创建过报名，第一次报名
                _addEnroll()
              }
            })
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      getTeacherListByIds (idsArr) {
        let idStr = ''
        if (idsArr && idsArr.length>0) {
          for (let i = 0; i<idsArr.length; i++) {
            if (i<idsArr.length-1) {
              idStr += idsArr[i] + ','
            } else if (i == idsArr.length-1) {
              idStr += idsArr[i]
            }
          }
        }
        this.$api.get(this.$global.teacherApiPath, '/teacher/batch', {ids: idStr}, r => {
          this.teacherList = r.data
        })
      },
      getCourseListByIds (idsArr) {
        this.$api.get(this.$global.courseApiPath, '/course/batch', {ids: utils.arr2str(idsArr)}, r => {
          this.resourceList = r.data
          utils.setVal(this.resourceList, 'typeName', '课程')
        })
      },
      getLivePlayListByIds (idsArr) {
        let s = utils.arr2str(idsArr)
        this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/batchGet', {ids: s}, r => {
          this.resourceList = r.data
          utils.setVal(this.resourceList, 'typeName', '直播')
        })
      },
      getPlanListByIds (idsArr) {
        this.$api.post(this.$global.planApiPath, '/trainingplans/search', {includedIds: idsArr}, r => {
          this.resourceList = r.data
          utils.setVal(this.resourceList, 'typeName', '计划')
        })
      }
    }
  }
</script>

<style scoped>
  .task_jihua_detail dl dt > span {
    width: auto;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    display: block;
    z-index: 1;
    padding: 0 5px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .task_jihua_detail dl dt > span.btn_end {
    background: #24282e;
  }
  .price_status {
    width: auto;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    display: block;
    z-index: 1;
    padding: 0 5px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/enroll/detail.vue